import {
    Component,
    inject,
    OnInit
} from "@angular/core";

import { MatDialogRef } from "@angular/material/dialog";
import { OpenDialogsService } from "../../services";

import {
    FormBuilder,
    type FormGroup,
    Validators
} from "@angular/forms";

import { Permissions } from "../models";


import { restManager } from "app/ajs-upgraded-providers";

@Component({
    standalone: false,
    selector: 'app-add-new-static-token-dialog.component',
    templateUrl: './add-new-static-token-dialog.component.html',
    styleUrls: ['./add-new-static-token-dialog.component.scss']
})
export class AddNewStaticTokenDialogComponent implements OnInit {
    private readonly formBuilder = inject(FormBuilder);
    private readonly restManagerService = inject(restManager);
    protected readonly dialogRef: MatDialogRef<OpenDialogsService> = inject(MatDialogRef)

    addNewStaticTokenDialogForm!: FormGroup;
    permissions: Permissions[] = [];
    // this was previous default list of permissions
    // private allPermissions: Permissions[] = [
    //     { value: 'SclStaticRO', title: '', description: ''},
    //     { value: 'SclStaticRW', title: '', description: ''},
    //     { value: 'SclStaticECom', title: '', description: ''},
    //     { value: 'SclStaticBookings', title: '', description: ''},
    //     { value: 'SclStaticStock', title: '', description: ''},
    //     { value: 'SclStaticCustomers', title: '', description: ''},
    //     { value: 'SclStaticStockCustomers', title: '', description: ''},
    //     { value: 'TheFork', title: '', description: ''},
    //     { value: 'Mago', title: '', description: ''},
    //     { value: 'Deliverect', title: '', description: ''},
    //     { value: 'MockPrinter', title: '', description: ''}
    // ];

    private populatePermissions() {
        // get list of permissions from backend
        this.restManagerService.getList("permissions/static_tokens/clients")
        .then((res: {"clientId": string, "description": string, "external": boolean}[]) => {
            this.permissions = [];
            // list can be empty if BE wants
            for(let client of res) {
                this.permissions.push({
                    value: client.clientId,
                    title: client.clientId,
                    description: client.description,
                    externalIntegration: client.external
                });
            }
            
        }).catch((err : any) => {
            console.error(err);
        });

    }


    ngOnInit(): void {
        this.populatePermissions();

        this.addNewStaticTokenDialogForm = this.formBuilder.group({
            description: ['', Validators.required],
            client_id: ['', Validators.required]
        });
    }

    submit() {
        if (this.addNewStaticTokenDialogForm.valid) {
            this.dialogRef.close(this.addNewStaticTokenDialogForm.value)
        } else {
            this.addNewStaticTokenDialogForm.markAllAsTouched();
        }
    }

    isFormInvalid(): boolean {
        return this.addNewStaticTokenDialogForm.invalid;
    }
}
